module.exports = __webpack_public_path__ + "img/exit_16.9cc3ab8a.svg";